/* Glaverra 3+1. Read-only cart companion; never adds products or changes prices. */
(() => {
  function offerState(data) {
    const quantity = Math.max(0, Math.floor(Number(data.quantity) || 0));
    const saving = Math.max(0, Math.round(Number(data.saving) || 0));
    const remainder = quantity % 4;
    const missing = quantity ? (remainder ? 4 - remainder : 0) : 4;
    let title, copy;
    if (!quantity) return { quantity, saving, missing, visible: false };
    if (!missing) {
      title = saving ? 'Akce 3+1 je vaše' : 'Čtveřici máte vybranou';
      copy = saving ? 'Sleva už je započítaná v ceně košíku.' : 'Uplatnění akce zkontrolujte v přehledu slev v košíku.';
    } else if (missing === 1) {
      title = quantity < 4 ? 'Ještě jeden do čtveřice' : 'Ještě jeden do další čtveřice';
      copy = 'Přidejte ještě 1 obraz a nejlevnější ze čtyř máte zdarma. Motiv si vyberete sami.';
    } else if (missing === 2) {
      title = 'Do akce 3+1 zbývají 2 obrazy';
      copy = 'Jeden pro sebe, další třeba jako dárek. Vyberte ještě 2 obrazy a využijte 3+1.';
    } else {
      title = 'Ze čtyř obrazů zaplatíte tři';
      copy = 'V košíku už máte první obraz do čtveřice. Přidejte ještě 3 a využijte akci 3+1.';
    }
    return { quantity, saving, missing, title, copy, visible: true, progress: remainder || 4, complete: !missing };
  }
  function shouldPrompt(previous, next, alreadyShown) {
    return !alreadyShown && next.quantity > previous && next.quantity >= 2 && next.missing > 0 && next.missing <= 2;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { offerState, shouldPrompt }; return; }
  const root = document.getElementById('glaverra-bundle');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const chip = root.querySelector('.gbn-chip'), panel = root.querySelector('.gbn-panel');
  const home = root.dataset.home, cartPath = root.dataset.cart;
  const onCart = location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '');
  const storageKey = 'glaverra-bundle-reminder-v1';
  let shown = false, storageAvailable = true;
  try { shown = sessionStorage.getItem(storageKey) === '1'; } catch { storageAvailable = false; }
  let state, currency = 'CZK', refreshTimer, visibilityTimer, pendingPrompt = false, requestVersion = 0, controller, dismissed = false;
  const visible = el => !!el && !el.hidden && !el.closest('details:not([open])') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  function obstructed() {
    return document.body.classList.contains('overflow-hidden') || Array.from(document.querySelectorAll('cart-drawer.active, .cart-notification.active, dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')).some(visible);
  }
  function money(amount) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'cs', { style: 'currency', currency, maximumFractionDigits: currency === 'CZK' ? 0 : 2 }).format(amount / 100); }
    catch { return (amount / 100).toFixed(2) + ' ' + currency; }
  }
  const mug = '<svg viewBox="0 0 34 30" fill="none" aria-hidden="true"><rect x="5" y="2" width="24" height="26" rx="1" stroke="currentColor" stroke-width="2"/><path d="m8 23 7-9 5 6 3-4 3 7M20 8h.01" stroke="currentColor" stroke-width="2"/></svg>';
  function progress() {
    return [1, 2, 3, 4].map(n => `<span class="gbn-mug${n <= state.progress ? ' is-filled' : ''}${n === 4 ? ' is-gift' : ''}${n === 4 && state.complete && state.saving ? ' is-earned' : ''}">${mug}</span>`).join('');
  }
  function fill(box) {
    box.querySelector('[data-title]').textContent = state.complete && state.saving ? `S akcí 3+1 ušetříte ${money(state.saving)}` : state.title;
    box.querySelector('[data-copy]').textContent = state.copy;
    box.querySelector('[data-progress]').innerHTML = progress();
    const link = box.querySelector('.gbn-cta'); link.hidden = state.complete;
    const terms = box.querySelector('.gbn-terms'); if (terms) terms.hidden = state.complete;
    box.classList.toggle('is-complete', state.complete);
  }
  function mountInline() {
    const targets = ['#main-cart-footer .cart__blocks', 'cart-drawer .drawer__footer', 'cart-notification .cart-notification__links'];
    for (const selector of targets) {
      const parent = document.querySelector(selector); if (!parent) continue;
      let box = parent.querySelector(':scope > .gbn-inline');
      if (!box) {
        box = document.createElement('section'); box.className = 'gbn-inline'; box.setAttribute('aria-label', 'Vaše akce 3+1');
        box.innerHTML = '<h3 data-title></h3><div class="gbn-progress" data-progress aria-hidden="true"></div><p class="gbn-copy" data-copy></p><a class="gbn-cta">Vybrat další obraz <span aria-hidden="true">→</span></a><p class="gbn-terms">Motivy i velikosti můžete kombinovat. Sleva na nejlevnější obrazy se započítá automaticky.</p>';
        box.querySelector('a').href = home; parent.prepend(box);
      }
      box.hidden = !state?.visible; if (state?.visible) fill(box);
    }
  }
  function markShown() { shown = true; try { sessionStorage.setItem(storageKey, '1'); } catch {} }
  function close(manual = false) {
    panel.hidden = true; chip.setAttribute('aria-expanded', 'false');
    if (manual) { dismissed = true; pendingPrompt = false; markShown(); }
    updateVisibility();
  }
  function open(manual = false) {
    if (!state?.visible || state.complete || obstructed()) return;
    fill(panel); panel.hidden = false; chip.hidden = true; chip.setAttribute('aria-expanded', 'true'); pendingPrompt = false; markShown();
    if (manual) panel.querySelector('.gbn-close').focus();
  }
  function updateVisibility() {
    clearTimeout(visibilityTimer);
    if (!state?.visible || state.complete || onCart || obstructed() || document.visibilityState === 'hidden') {
      chip.hidden = true; panel.hidden = true; chip.setAttribute('aria-expanded', 'false');
      if (pendingPrompt && !onCart && !state?.complete) visibilityTimer = setTimeout(updateVisibility, 1200);
      return;
    }
    if (pendingPrompt && !dismissed && !shown && storageAvailable) open();
    chip.hidden = !panel.hidden;
  }
  function apply(data, trigger = false) {
    const previous = state?.quantity ?? 0; state = offerState(data); currency = data.currency || 'CZK';
    if (shouldPrompt(previous, state, shown) && trigger) pendingPrompt = true;
    if (!state.visible || state.complete) pendingPrompt = false;
    root.querySelector('[data-chip-text]').textContent = state.missing === 1 ? 'Do akce chybí 1 obraz' : `Do akce chybí ${state.missing} obrazy`;
    if (state.visible) fill(panel);
    mountInline(); updateVisibility();
  }
  async function refresh(trigger = false) {
    const version = ++requestVersion; controller?.abort(); controller = new AbortController();
    try {
      const url = new URL(cartPath, location.origin); url.searchParams.set('section_id', 'glaverra-bundle-state');
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw Error('Cart unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('[data-glaverra-bundle-state]').textContent);
      if (version === requestVersion) apply(data, trigger);
    } catch (error) {
      if (error.name !== 'AbortError' && version === requestVersion) {
        state = null; pendingPrompt = false;
        chip.hidden = panel.hidden = true;
        document.querySelectorAll('.gbn-inline').forEach(el => { el.hidden = true; });
      }
    }
  }
  function schedule() { clearTimeout(refreshTimer); refreshTimer = setTimeout(() => refresh(true), 250); }
  chip.addEventListener('click', () => open(true));
  root.querySelector('.gbn-close').addEventListener('click', () => { close(true); if (!chip.hidden) chip.focus(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) close(true); });
  document.addEventListener('click', e => { if (!panel.hidden && !root.contains(e.target)) close(true); });
  // A same-page catalogue link closes the reminder without trapping focus.
  document.addEventListener('click', e => { if (e.target.closest('.gbn-cta')) { pendingPrompt = false; close(true); document.querySelector('cart-drawer.active')?.close(); document.querySelector('cart-notification')?.close?.(); } });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  // Covers other existing cart integrations without replacing fetch/XHR.
  if ('PerformanceObserver' in window) {
    try { new PerformanceObserver(list => { if (list.getEntries().some(e => { try { const u = new URL(e.name); return u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname); } catch { return false; } })) schedule(); }).observe({ type: 'resource', buffered: false }); } catch {}
  }
  const observer = new MutationObserver(() => { clearTimeout(visibilityTimer); visibilityTimer = setTimeout(() => { mountInline(); updateVisibility(); }, 300); });
  for (const el of document.querySelectorAll('cart-drawer, cart-notification, .cart-notification, #shopify-pc__banner')) observer.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], subtree: false });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', () => refresh(false));
  window.addEventListener('focus', () => refresh(false));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(false); });
  try { apply(JSON.parse(root.querySelector('[data-glaverra-bundle-state]').textContent)); } catch { refresh(false); }
})();
